import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/shows';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-xl border-b border-foreground-50/10'
          : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between h-16 md:h-18 px-4 md:px-8">
        <Link to="/" className="flex items-center gap-2 group whitespace-nowrap">
          <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-movie-2-line text-lg md:text-xl text-background-950"></i>
          </div>
          <span className="text-lg md:text-xl font-bold text-foreground-950 tracking-wide group-hover:text-primary-400 transition-colors duration-300" style={{ fontFamily: 'var(--font-heading)' }}>
            爱丫爱丫影院
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {categories.slice(0, 7).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="px-3 py-2 text-sm text-foreground-600 hover:text-primary-400 rounded-lg hover:bg-foreground-50/5 transition-all duration-200 whitespace-nowrap"
            >
              {cat.name}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/about"
            className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors duration-200 whitespace-nowrap"
          >
            关于我们
          </Link>
          <button className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-50/10 hover:bg-foreground-50/20 transition-colors duration-200 cursor-pointer">
            <i className="ri-search-line text-foreground-600"></i>
          </button>
          <Link
            to="/category/all"
            className="px-5 py-2 text-sm font-semibold rounded-lg bg-primary-500 text-background-950 hover:bg-primary-400 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            立即观看
          </Link>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-50/10 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i className={`text-foreground-600 text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-xl border-t border-foreground-50/10 px-4 py-4 animate-in slide-in-from-top">
          <div className="grid grid-cols-3 gap-2 mb-4">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                onClick={() => setMobileOpen(false)}
                className="px-3 py-2.5 text-sm text-foreground-600 hover:text-primary-400 bg-background-100 rounded-lg text-center transition-all duration-200 whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
          </div>
          <div className="flex items-center gap-3 pt-3 border-t border-foreground-50/10">
            <Link
              to="/about"
              onClick={() => setMobileOpen(false)}
              className="flex-1 text-center py-2.5 text-sm text-foreground-500 bg-background-100 rounded-lg whitespace-nowrap"
            >
              关于我们
            </Link>
            <Link
              to="/category/all"
              onClick={() => setMobileOpen(false)}
              className="flex-1 text-center py-2.5 text-sm font-semibold bg-primary-500 text-background-950 rounded-lg whitespace-nowrap"
            >
              立即观看
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}